module.exports = __webpack_public_path__ + "static/media/mirador-centinela-low.1fd0a4ca.mp4";